export default "__VITE_ASSET__b1397fd7__"